import { Component, inject } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { IVideoDetails } from './video-details';

@Component({
  selector: 'kh-watch-video',
  styleUrls: ['./watch-video.component.less'],
  templateUrl: './watch-video.component.html',
  standalone: false
})
export class WatchVideoComponent implements IVideoDetails {
  private readonly bsModalRef = inject(BsModalRef);

  public closeIcon = faTimes;
  public title = '';
  public videoId = '';
  public description = '';

  public close(): void {
    this.bsModalRef.hide();
  }
}
